import api from './api';
import {
  Project,
  ProjectCreateDto,
  ProjectUpdateDto,
  ProjectStatus,
  AssignToProjectDto
} from '../types/project';

export const projectService = {
  // Get all projects
  async getAll(status?: ProjectStatus, search?: string, includeArchived: boolean = false): Promise<Project[]> {
    const params = new URLSearchParams();
    if (status !== undefined) params.append('status', status.toString());
    if (search) params.append('search', search);
    params.append('includeArchived', includeArchived.toString());

    const response = await api.get<Project[]>(`/projects?${params.toString()}`);
    return response.data;
  },

  // Get project by ID
  async getById(id: number): Promise<Project> {
    const response = await api.get<Project>(`/projects/${id}`);
    return response.data;
  },

  // Create new project
  async create(data: ProjectCreateDto): Promise<Project> {
    const response = await api.post<Project>('/projects', data);
    return response.data;
  },

  // Update project
  async update(id: number, data: ProjectUpdateDto): Promise<Project> {
    const response = await api.put<Project>(`/projects/${id}`, data);
    return response.data;
  },

  // Delete project
  async delete(id: number): Promise<void> {
    await api.delete(`/projects/${id}`);
  },

  // Document assignments
  async assignDocument(projectId: number, dokumentId: number): Promise<void> {
    const data: AssignToProjectDto = {
      projectID: projectId,
      itemID: dokumentId
    };
    await api.post(`/projects/${projectId}/documents`, data);
  },

  async removeDocument(projectId: number, dokumentId: number): Promise<void> {
    await api.delete(`/projects/${projectId}/documents/${dokumentId}`);
  },

  // Ticket assignments
  async assignTicket(projectId: number, ticketId: number): Promise<void> {
    const data: AssignToProjectDto = {
      projectID: projectId,
      itemID: ticketId
    };
    await api.post(`/projects/${projectId}/tickets`, data);
  },

  async removeTicket(projectId: number, ticketId: number): Promise<void> {
    await api.delete(`/projects/${projectId}/tickets/${ticketId}`);
  },

  // Mail assignments
  async assignMail(projectId: number, emailId: number): Promise<void> {
    const data: AssignToProjectDto = {
      projectID: projectId,
      itemID: emailId
    };
    await api.post(`/projects/${projectId}/mails`, data);
  },

  async removeMail(projectId: number, emailId: number): Promise<void> {
    await api.delete(`/projects/${projectId}/mails/${emailId}`);
  },

  // Address assignments
  async assignAddress(projectId: number, adresseId: number, rolle?: string): Promise<void> {
    const data: AssignToProjectDto = {
      projectID: projectId,
      itemID: adresseId,
      rolle
    };
    await api.post(`/projects/${projectId}/addresses`, data);
  },

  async removeAddress(projectId: number, adresseId: number): Promise<void> {
    await api.delete(`/projects/${projectId}/addresses/${adresseId}`);
  },

  // User/Team assignments
  async assignUser(projectId: number, benutzerId: number, rolle?: string): Promise<void> {
    const data: AssignToProjectDto = {
      projectID: projectId,
      itemID: benutzerId,
      rolle
    };
    await api.post(`/projects/${projectId}/users`, data);
  },

  async removeUser(projectId: number, benutzerId: number): Promise<void> {
    await api.delete(`/projects/${projectId}/users/${benutzerId}`);
  },
};
